import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "logincollege",
    component: () =>
      import(
        /* webpackChunkName: "logincollege" */ "../views/login-college.vue"
      )
  },
  {
    path: "/main",
    name: "main",
    component: () => import(/* webpackChunkName: "main" */ "../views/main.vue")
  },
  {
    path: "/screen",
    name: "screen",
    component: () => import(/* webpackChunkName: "screen" */ "../views/screen.vue")
  },
  {
    path: "/data-view",
    name: "dataview",
    component: () => import(/* webpackChunkName: "dataview" */ "../views/data-view/index.vue")
  },
  {
    path: "/examinee",
    name: "examinee",
    component: () => import(/* webpackChunkName: "examinee" */ "../views/examinee.vue")
  },
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/login.vue")
  },
  {
    path: "*",
    redirect: "/"
  }
];

const router = new VueRouter({
  routes
});

export default router;
